export default __webpack_public_path__ + "static/media/LV.6f6eaa7b.svg";